import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Account} from '../models/account.model';
import { AccountsResult } from '../models/accounts-result.model';
import { defaultAccountsResult } from '../models/accounts-result.model';
import { DocsIncludedResponse } from '../models/docs-included-response.model';
import { MOCK_RESPONSE } from './mock-response';
import { PershingError } from '@pershing/pershing-core';

@Injectable()
export class MockEdeliveryService {

    baseUrl = 'https://r00m25p0c.bnymellon.net:11771/edc/edelivery/';
    listOfAccountsChanged: Account[] = [];
    backButtonClicked: boolean = false;
    showAgreement$: Observable<boolean>;
    private _showAgreement: BehaviorSubject<boolean>;
    trackingList = [];
    listToBeSubmitted = [];
    previousSettings: any[] = [];
    currentSettings: any[] = [];
    savedSettings: any[] = [];
    previouslyEnrolled = new Map<String, number>();
    changeView$: Observable<any>;
    allDocumentNamesNotDisplayed: any = [];
    accountsMap = new Map<string, Object[]>();
    finalListOfAccounts: Account[] = [];
    preferencesSubmitted: boolean = false;
    preferencesResponse$: Observable<AccountsResult>;
    error$: Observable<PershingError>;
    loading$: Observable<boolean>; // Remove this in Sprint 12 when timer is removed
    confirmationResponse$: Observable<AccountsResult>;
    docsIncludedResponse$: Observable<DocsIncludedResponse>;
    private _preferencesResponse: BehaviorSubject<AccountsResult>;
    private _error: BehaviorSubject<PershingError>;
    private _loading: BehaviorSubject<boolean>; // Remove this in Sprint 12 when timer is removed
    private _confirmationResponse: BehaviorSubject<AccountsResult>;
    private _docsIncludedReponse: BehaviorSubject<DocsIncludedResponse>;
    private dataStore: {
        preferencesResponse: AccountsResult,
        confirmationResponse: AccountsResult,
        docIncluded: DocsIncludedResponse
    };

    constructor() {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this.dataStore = { preferencesResponse: null, confirmationResponse: null, docIncluded: null };
        this._preferencesResponse = <BehaviorSubject<AccountsResult>>new BehaviorSubject(defaultAccountsResult());
        this.preferencesResponse$ = this._preferencesResponse.asObservable();
        this._loading = new BehaviorSubject<boolean>(false);
        this.loading$ = this._loading.asObservable();
        this._showAgreement = new BehaviorSubject<boolean>(false);
        this.showAgreement$ = this._showAgreement.asObservable();
        this._confirmationResponse = <BehaviorSubject<AccountsResult>>new BehaviorSubject(defaultAccountsResult());
        this.confirmationResponse$ = this._confirmationResponse.asObservable();
        this._docsIncludedReponse = <BehaviorSubject<DocsIncludedResponse>>new BehaviorSubject(null);
        this.docsIncludedResponse$ = this._docsIncludedReponse.asObservable();
    }

    retrievePreferences() {
        let data: any = MOCK_RESPONSE;
        console.log('mock data: ', data);
        // this.logService.log(data);
        let accountsResult: AccountsResult = defaultAccountsResult();
        accountsResult.accounts = data.response;
        console.log('mock data response: ', accountsResult.accounts);
        this.dataStore.preferencesResponse = accountsResult;
        this._preferencesResponse.next(Object.assign({}, this.dataStore).preferencesResponse);
    }

    updatePreferences(ListOfAccounts): void {
        console.log('mock updatePreferences getting called');
        let data: any = MOCK_RESPONSE;
        let accountsResult: AccountsResult = defaultAccountsResult();
        accountsResult.accounts = data.response;
        this.dataStore.preferencesResponse = accountsResult;
        this.dataStore.confirmationResponse = accountsResult;
        this._preferencesResponse.next(Object.assign({}, this.dataStore).preferencesResponse);
        this._confirmationResponse.next(Object.assign({}, this.dataStore).confirmationResponse);
    }

    retrieveDocInclusion(docType) {
        // Change this to fit the actual call.
        // let data =
        // this.dataStore.docIncluded = data;
        // this._docsIncludedReponse.next(Object.assign({}, this.dataStore).docIncluded);
    }

    addChangedAccount(account: Account): void {
        // Here we want to add any account that got changed in the preferences so that we know which accounts were changed when clicking save.
        console.log('eDelivery addChangedAccount: ', account);
        if (this.listOfAccountsChanged.length === 0) {
            this.listOfAccountsChanged.push(account);
        } else {
            for (let i = 0; i < this.listOfAccountsChanged.length; i++) {
                if (this.listOfAccountsChanged[i].accountNumber === account.accountNumber) {
                    this.listOfAccountsChanged[i] = account;
                    break;
                } else if (i === this.listOfAccountsChanged.length - 1) {
                    this.listOfAccountsChanged.push(account);
                }
            }
        }
        console.log('list of accounts changed: ', this.listOfAccountsChanged);
    }

    findQuickEnrolled() {
        if (this.previousSettings.length !== this.allDocumentNamesNotDisplayed.length) {
            for (let j = 0; j < this.dataStore.preferencesResponse.accounts.length; j++) {
                let account = this.dataStore.preferencesResponse.accounts[j];
                for (let i = 0; i < account.edeliveryDocuments.length; i++) {
                    if (account.edeliveryDocuments[i].preferenceType.deliveryPreference === 2) { // Enrolled
                        let value = this.previouslyEnrolled.get(account.edeliveryDocuments[i].edocumentType.docTypeDesc);
                        if (value === undefined) {
                            this.previouslyEnrolled.set(account.edeliveryDocuments[i].edocumentType.docTypeDesc, 1);
                        } else {
                            this.previouslyEnrolled.set(account.edeliveryDocuments[i].edocumentType.docTypeDesc, value + 1);
                        }
                    }
                }
            }
            for (let i = 0; i < this.allDocumentNamesNotDisplayed.length; i++) {
                if (this.previouslyEnrolled.get(this.allDocumentNamesNotDisplayed[i]) >= this.dataStore.preferencesResponse.accounts.length) {
                    this.previousSettings.push(true);
                    this.currentSettings.push(true);
                } else {
                    this.previousSettings.push(false);
                    this.currentSettings.push(false);
                }
            }
        }
    }

    createTrackingList() {
        if (this.dataStore.preferencesResponse !== null) {
            this.trackingList = JSON.parse(JSON.stringify(this.dataStore.preferencesResponse.accounts));
            console.log('tracking list: ', this.trackingList);
        }
    }

    goToAgreement() {
        this.savedSettings = JSON.parse(JSON.stringify(this.currentSettings));
        this._showAgreement.next(true);
        this.backButtonClicked = false;
    }

    backButton() {
        this._showAgreement.next(false);
        this.backButtonClicked = true;
    }

    closingDialog() {
        this._showAgreement.next(false);
    }

    submitPreferences() {
        console.log('mock submitPreferences getting called');
        this.updatePreferences(this.finalListOfAccounts);
    }

    // checkAccountPreferences(originalAccount, changedAccountDocuments, index) {
    //     // If account preferences are the same, delete from trackingList
    //     // Set tempAccount.edeliveryDocuments to none
    //     this.listToBeSubmitted[index].edeliveryDocuments = [];
    //     for (let j = 0; j < originalAccount.edeliveryDocuments.length; j++) {
    //         if (originalAccount.edeliveryDocuments[j].preferenceType.deliveryPreference !== changedAccountDocuments[j].preferenceType.deliveryPreference) {
    //             // Only if settings are different, would each account's preferences have changed.
    //             if (this.previousSettings[j] !== this.currentSettings[j]) {
    //                 this.listToBeSubmitted[index].edeliveryDocuments.push(changedAccountDocuments[j]);
    //                 if (this.finalListOfAccounts.length === 0) {
    //                     this.finalListOfAccounts.push(this.listToBeSubmitted[index]);
    //                 } else {
    //                     this.insertIntoFinalList(this.listToBeSubmitted[index]);
    //                 }
    //             }
    //         }
    //     }
    // }

    insertIntoFinalList(accountBeingInserted) {
        for (let x = 0; x < this.finalListOfAccounts.length; x++) {
            if (this.finalListOfAccounts[x].accountNumber === accountBeingInserted.accountNumber) {
                // Only insert the preferences
                this.finalListOfAccounts[x].edeliveryDocuments = accountBeingInserted.edeliveryDocuments;
                return;
            }
        }
        this.finalListOfAccounts.push(accountBeingInserted);
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'AccountsService', errorCode));
    }

    clearError(): void {
        this._error.next(null);
    }
}
